/**
 * Created by piotr.pozniak@thebeaverhead.com on 15/02/2023.
 */

import React from "react";

import PropTypes from "prop-types";
import { IT } from "../../../../../consts";
import Accordion from "../../../component/WidgetSettings/Acordion";
import { ucFirst } from "../../../../../helpers/string";
import classNames from "classnames";
import IntegrationSelect from "../../../component/Integration/IntegrationSelect";

const MandatoryInformation = (props) => {
  /**
   *
   * @param fieldName
   * @param callback
   * @returns {function(*=): void}
   */
  const onFormFieldChange = (fieldName) => (e) => {
    props.onUpdateField(fieldName, e.target.value);
  };

  const subtitle = props.showSummary
    ? `${ucFirst(props.alertModel.name)} alert widget using ${IT[
        props.alertModel.integration.type
      ].toUpperCase()} integration.`
    : null;

  return (
    <Accordion
      title={"Name & Integration"}
      subtitle={subtitle}
      keepExpanded={props.expanded}
    >
      <form action="#">
        <div className="form-group">
          <div className="col-xs-12">
            <label htmlFor={"alert_name"} className={""}>
              Widget Name
            </label>
            <input
              type="text"
              className={classNames("form-control", {
                "is-invalid": props.formErrors.nameError,
              })}
              placeholder="Widget Name"
              id="alert_name"
              onChange={onFormFieldChange("name")}
              value={props.alertModel.name || ""}
              disabled={props.disabled}
            />
          </div>
        </div>
        <IntegrationSelect
          onChange={onFormFieldChange("integration_uuid")}
          disabled={props.disabled}
          selectedIntegrationUUID={props.alertModel.integration_uuid}
          error={props.formErrors.integrationError}
        />
      </form>
    </Accordion>
  );
};

MandatoryInformation.defaultProps = {
  expanded: false,
  showSummary: true,
};
MandatoryInformation.propTypes = {
  alertModel: PropTypes.object.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  integrations: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  showSummary: PropTypes.bool,
};

export default MandatoryInformation;
